<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard-brands', params: { vendorId } }">
    <div class="vendor-brand-create">
      <crud-edit
        v-bind="editConfiguration"></crud-edit>
    </div>
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CrudEdit from "@/client/components/crud/customV1/Edit.vue";
import vendorBrandCreateFromConfigFactory from "@/client/applications/justopp/assets/static/forms/vendorBrandFormFactory.js";
import Block from "@/client/components/base/frameworks/we/html/Block";
import { computed } from 'vue'

export default {
  components: {CrudEdit },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.vendorBrandUpdate.pageTitle",
      subTitle: "justopp.vendorBrandUpdate.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
    brandId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.vendorBrandUpdate.browserTitle",
  data() {

    return {
      editConfiguration: {
        itemId: this.brandId,
        subject: "brand",
        itemSrc: computed(() => "justopp/brand/" + this.brandId),
        submitUrl: computed(() => {
          return "justopp/brand/" + this.brandId;
        }),
        showCancelButton: false,
        cancelRedirect: {
          name: "company-vendorId-dashboard-brands",
          params: { vendorId: this.vendorId },
        },
        successRedirect: {
          name: "company-vendorId-dashboard-brands",
          params: { vendorId: this.vendorId },
        },
        initialItemData: {

        },
        formConfig: vendorBrandCreateFromConfigFactory({
          vendorId: this.vendorId,
          userProfile: this.$store.getters['user/profile'],
        }),
      },
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  created() {

  },
  methods: {
    handleItemUpdated({ itemData }) {

    },
  },
};
</script>

<style lang="scss">
.vendor-deal-create {
  .form {
    .fields {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .top-block {
        order: 100;
        flex: 0 0 100%;
      }
/*
      .form__fieldset {
        flex: 0 0 48%;

        @media (max-width: 1024px) {
          flex: 0 0 100%;
        }

        &.translations {
          flex: 0 0 100%;
        }
      }
      */
    }
  }
}
</style>

<style lang="scss" scoped></style>
